angular.module('CarsSaraBo').factory('AlertEmailService', ['$resource', function($resource) {
  return $resource('../rest/company/:companyOid/alertEmail/:oid', 
    { 
	  companyOid : '@companyOid',
	  oid : '@oid' 
    },
    {
    	update : { method: 'PUT' }
    }
  )}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/alert-emails/alert-email.service.js
// module id = 934
// module chunks = 3